module.exports = __webpack_public_path__ + "media/images/create_golf_hub_page-73cc913d.svg";